import PrestacaoContaAPI from '@/api/prestacaocontas'

export default {
  clear({ commit }) {
    commit('SET_PRESTACOES', [])
    commit('SET_DEMONSTRATIVO', {})
  },
  fetchAll({ commit }, params) {
    return new Promise((resolve, reject) => {
      PrestacaoContaAPI.list(params.pagina)
        .then(response => {
          commit('ADD_PRESTACOES', response.data)
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  fetchDemonstrativo({ commit }, params) {
    return new Promise((resolve, reject) => {
      PrestacaoContaAPI.demonstrativo(params.referencia)
        .then(response => {
          commit('SET_DEMONSTRATIVO', response.data)
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  // eslint-disable-next-line
  fetchPdf({ commit }, params) {
    return new Promise((resolve, reject) => {
      PrestacaoContaAPI.getPdf(params.arquivoId)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  fetchParecer({ commit }, params) {
    return new Promise((resolve, reject) => {
      PrestacaoContaAPI.getParecer(params.id)
        .then(response => {
          commit('SET_PARECER', response.data)
          resolve(response)
        })
        .catch(error => {
          commit('SET_PARECER', null)
          reject(error)
        })
    })
  },
  aprovar({ commit }, params) {
    return new Promise((resolve, reject) => {
      PrestacaoContaAPI.aprovar(params.id, params.ressalvas)
        .then(response => {
          commit('SET_PARECER', response.data)
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  reprovar({ commit }, params) {
    return new Promise((resolve, reject) => {
      PrestacaoContaAPI.reprovar(params.id, params.ressalvas)
        .then(response => {
          commit('SET_PARECER', response.data)
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
}
